import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import map from 'lodash/map';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Info from 'svg/info.svg';
import messages from '../../../messages';
import styles from './PartnerApplicationDisclaimers.pcss';
const requiredDisclaimers = [
    'disconnectApp',
    'offlineAccess'
];
const partnerApplicationDisclaimers = requiredDisclaimers.map((disclaimer)=>({
        id: disclaimer,
        message: messages.disclaimers[disclaimer]
    }));
const PartnerApplicationDisclaimers = ()=>/*#__PURE__*/ _jsx("div", {
        className: styles.container,
        children: map(partnerApplicationDisclaimers, (item)=>{
            var _item_message;
            return /*#__PURE__*/ _jsxs("div", {
                className: styles.disclaimer,
                children: [
                    /*#__PURE__*/ _jsx(Info, {
                        className: styles.disclaimer__icon
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.disclaimer__text,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: (_item_message = item.message) === null || _item_message === void 0 ? void 0 : _item_message.id
                        })
                    })
                ]
            }, item.id);
        })
    });
export default withStyles(styles)(PartnerApplicationDisclaimers);
